import { render } from "./MyResults.vue?vue&type=template&id=da9b1e4c&scoped=true"
import script from "./MyResults.vue?vue&type=script&lang=js"
export * from "./MyResults.vue?vue&type=script&lang=js"

import "./MyResults.vue?vue&type=style&index=0&id=da9b1e4c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9b1e4c"]])

export default __exports__